import ResourceTyped from 'Resources/ResourceTyped';
import { OptIn } from 'App/babel/helpers/formOptIns';

class OptInResource extends ResourceTyped<OptIn> {
	constructor() {
		super('optIn');
	}
}

const resource = new OptInResource();

export default resource;
